let memoryAnonymousId: string | undefined;
const GROWTH_EVENT_SESSION_KEY = 'musicmint_growth_event_session_id';
const GROWTH_EVENT_ANONYMOUS_KEY = 'musicmint_growth_event_anonymous_id';

export const createGrowthEventId = () => {
  const cryptoApi = typeof globalThis !== 'undefined' ? globalThis.crypto : undefined;
  if (cryptoApi && typeof cryptoApi.randomUUID === 'function') {
    return cryptoApi.randomUUID();
  }
  return `web-${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

export const getGrowthEventSessionId = () => {
  if (typeof window === 'undefined') {
    return 'server';
  }

  try {
    const existing = window.sessionStorage.getItem(GROWTH_EVENT_SESSION_KEY);
    if (existing) return existing;

    const next = createGrowthEventId();
    window.sessionStorage.setItem(GROWTH_EVENT_SESSION_KEY, next);
    return next;
  } catch {
    return createGrowthEventId();
  }
};

export const getGrowthEventAnonymousId = () => {
  if (typeof window === 'undefined') {
    return 'server';
  }

  try {
    const existing = window.localStorage.getItem(GROWTH_EVENT_ANONYMOUS_KEY);
    if (existing && /^[A-Za-z0-9_.:-]{1,128}$/.test(existing)) return (memoryAnonymousId = existing);

    const next = memoryAnonymousId ||= createGrowthEventId();
    window.localStorage.setItem(GROWTH_EVENT_ANONYMOUS_KEY, next);
    return next;
  } catch {
    return memoryAnonymousId ||= createGrowthEventId();
  }
};
